<script setup>
import { ref } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useRouter } from "vue-router";
import AddCard from "/src/components/molecules/AddCard.vue";

const cardsInfo = ref(null);
const defaultCard = ref(null);
async function getCreditCard() {
  console.log("function呼び出し");
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  const myCallableFunction = httpsCallable(functions, "Common_cardslist");
  myCallableFunction({})
    .then((result) => {
      console.log(result.data.cards.data);
      console.log(result.data.defaultCardId);
      cardsInfo.value = result.data.cards.data;
      defaultCard.value = result.data.defaultCardId;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log(error.message);
    });
}
getCreditCard();

const router = useRouter();
const toLink = (url) => {
  router.push(url);
};

const dialog = ref(false);
const dialogfun = () => {
  console.log("aaa");
  dialog.value = true;
};

const addcardclose = () => {
  dialog.value = false;
};

const addcardcloseandload = () => {
  dialog.value = false;
  getCreditCard();
};

const selectdeleteCard = (index) => {
  console.log(index);
  const functions = getFunctions();
  functions.region = "asia-northeast1"; // これを追加
  const addMessage = httpsCallable(functions, "Common_deleteCard");
  const cardId = cardsInfo.value[index].id;
  console.log(cardId);
  addMessage({ card_id: cardId })
    .then((result) => {
      console.log(result);
      getCreditCard();
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log(error.message);
    });
};

const setDefaulcard = async (id) => {
  console.log(id);
  const functions = getFunctions();
  functions.region = "asia-northeast1"; // これを追加
  const addMessage = httpsCallable(functions, "Goods_SetDefaultCard");
  await addMessage({
    defaultCard: id,
  }).then((res) => {
    console.log(res);
    // dialog.value = false;
    location.reload();
  });
};
</script>
<template>
  <v-app>
    <div>
      <h2 class="mt-12 title">お支払い先情報</h2>
    </div>
    <div v-for="(card, index) in cardsInfo" :key="index" class="pa-2 box" xs12 md9>
      <div class="cardbrand">
        {{ card.brand }}
      </div>
      <div class="cardno">**** **** **** {{ card.last4 }}</div>
      <div class="expireAndDefault">
        <div class="cardexpire">有効期限 {{ card.exp_month }} / {{ card.exp_year }}</div>
        <div v-if="card.id === defaultCard" class="defaultCard">デフォルト</div>
        <div v-if="card.id !== defaultCard" class="setdefaultCard" @click="setDefaulcard(card.id)">
          デフォルトに設定
        </div>
      </div>
      <div class="carddelete" color="error" @click="selectdeleteCard(index)">ー削除</div>
    </div>

    <div>
      <v-btn
        variant="outlined"
        class="mt-5 ml-5 addbobtn"
        height="25"
        width="134"
        rounded="pill"
        @click="dialogfun()"
      >
        <a class="addpayment">+お支払い情報の追加</a>
      </v-btn>
    </div>
    <v-dialog v-model="dialog" max-width="400">
      <AddCard @addcardclose="addcardclose" @addcardcloseandload="addcardcloseandload" />
      <!-- <v-row class="dialogtitle pt-5 pb-5" height="100px" justify="center"
        >クレジットカード情報の追加</v-row
      >

      <div class="dialog">
        <div class="cardtitle">カード番号</div>
        <input class="cardinput" type="number" v-model="cardno" />

        <div class="cardtitle">有効期限</div>
        <div class="bottonconteiner">
          <select v-model="exmonth" class="monthinput">
            <option disabled value="">月</option>
            <option>01</option>
            <option>02</option>
            <option>03</option>
            <option>04</option>
            <option>05</option>
            <option>06</option>
            <option>07</option>
            <option>08</option>
            <option>09</option>
            <option>10</option>
            <option>11</option>
            <option>12</option>
          </select>
          <select v-model="exyear" class="yearinput">
            <option disabled value="">年</option>
            <option>2023</option>
            <option>2024</option>
            <option>2025</option>
            <option>2026</option>
            <option>2027</option>
            <option>2028</option>
            <option>2029</option>
            <option>2030</option>
            <option>2031</option>
            <option>2032</option>
            <option>2033</option>
          </select>
        </div>
        <div class="cardtitle">セキュリティーコード（CVC）</div>
        <input class="cvccode" type="text" placeholder="" v-model="cvc" />
        <div class="credittypetitle">以下のクレジットカードをご利用いただけます。</div>
        <div class="bottonconteiner">
          <div class="" @click="toLink('myaccount')">
            <v-btn class="ml-5" height="30" width="80" rounded="pill" color="rgba(226, 226, 226)">
              <a class="return">キャンセル</a>
            </v-btn>
          </div>
          <div>
            <v-btn
              class="ml-5"
              height="30"
              width="80"
              rounded="pill"
              @click="addcardfun"
              color="rgba(89, 117, 156)"
            >
              <a class="addpayment">カードを追加</a>
            </v-btn>
          </div>
        </div>
      </div> -->
    </v-dialog>
    <div class="returncontainer" @click="toLink('myaccount')">
      <v-btn variant="outlined" height="30" width="65" rounded="pill" color="black" class="btn">
        <a class="return">戻る</a>
      </v-btn>
    </div>
  </v-app>
</template>

<style scoped>
/* .form {
  width: 100%;
} */
.maincontainer {
  margin: 0 0 50px 0;
}
.title {
  font-size: 14px;
  margin: 0 0 10px 0;
}
.box {
  border-radius: 15px;
  border: 1px solid #000;
  background-color: white;
  width: 300px;
  height: 60px;
  padding: 0.5em 1em;
  margin: 2em 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  box-shadow: rgba(233, 233, 233, 0.9) 3px 3px 0px 0px;
}
.cardbrand {
  font-size: 12px;
  margin: 8px 250px 0px 0;
}
.cardno {
  font-size: 12px;
  margin: -14px 100px 0px 0;
}
.cardexpire {
  font-size: 12px;
  margin: -17px -160px 0px 0;
}
.carddelete {
  font-size: 12px;
  color: red;
  margin: 15px -240px 0px 0;
}
.addpayment {
  color: rgb(217, 217, 217);
  font-size: 10px;
}
.returncontainer {
  margin: 100px 0 0 0;
}
.return {
  color: rgb(142 144 147);
  font-size: 12px;
}
.dialog {
  background-color: white;
  padding: 0.5em 1em;
  margin: 0 0;
  background: #fff;
  border: solid 1px;
  border-radius: 0 0 10px 10px; /*角の丸み*/
}

.dialogtitle {
  margin: 0 0 0 0;
  /* padding: 0.5em 1em; */
  background: #fff;
  border: solid 1px;
  border-radius: 10px 10px 0 0; /*角の丸み*/
  background-color: rgb(142 144 147);
}

.btn {
  background-color: rgb(226, 226, 226);
  box-shadow: rgba(233, 233, 233, 0.9) 3px 3px 0px 0px;
}
.addbobtn {
  background-color: rgb(155, 155, 155);
  box-shadow: rgba(233, 233, 233, 0.9) 3px 3px 0px 0px;
}
.defaultCard {
  font-size: 12px;
  margin-top: 5px;
  margin-left: 220px;
}
.setdefaultCard {
  font-size: 12px;
  margin-top: 5px;
  margin-left: 180px;
}
/*スマートフォン-----------------------------------------------------------------------------------*/
/*@media only screen and (max-width:768px){*/
@media only screen and (max-width: 1000px) {
  .login {
    color: rgb(255 255 255);
    font-size: 12px;
  }
}
</style>
